import '../styling/NewInvoiceDetailsList.css';
import userimage from '../resources/invoice.png'
import { useParams } from 'react-router-dom';
import {useEffect, useState} from 'react';
import {useAuthContext} from "../hooks/useAuthContext"
import API_BASE_URL from '../config.js';



const NewInvoiceDetailsList = () => {

    const { invoiceId } = useParams();
    const {user} = useAuthContext();

    const[firstName,setFirstName] = useState('');
    const[lastName,setLastName] = useState('')
    const[message,setMessage] = useState('');
    const[lineItems,setLineItems] = useState([]);
    const[invoiceTotal,setInvoiceTotal] = useState('');
    const[issuedDate,setIssuedDate] = useState('');
    const[payment,setPayment] = useState('');
    const[subject,setSubject] = useState('');

    useEffect(() => {
        const fetchClients = async () => {
    
            const response = await fetch(`${API_BASE_URL}/api/invoice/${invoiceId}`, {
                headers: {"Authorization": `Bearer ${user.token}`}
            })
    
            const json = await response.json()
    
            if(response.ok){
                setFirstName(json.client.clientFirst);
                setLastName(json.client.clientLast);
                setMessage(json.client.clientMessage);
                setLineItems(json.lineItems);
                setInvoiceTotal(json.invoiceTotal);
                setIssuedDate(json.issuedDate);
                setPayment(json.paymentDue);
                setSubject(json.invoiceSubject);
            }     
        }
        if (user){
            fetchClients()
        }  

      }, [])
    return ( 
    
        <div className="newcreatequoteformcontainer2">
            <div className="newclientitle2">
                <div className="title2left">
                    <div className="newformleftcircle" id="quotecircle3">
                    <img src={userimage} alt="" />
                    </div>
                    {firstName ? <h1 className="text-3xl font-bold ml-4">Invoice for: {firstName} {lastName}</h1> : <h1 className="text-3xl font-bold ml-4">Invoice for: FirstName LastName</h1>}
                </div>
                <div className="title3right">
                <div className="righthalf1">
                    <h1><b>Issued Date</b></h1>
                    {issuedDate ? <h1>{issuedDate}</h1> : <h1>N/A</h1> }
                   </div>
                   <div className="righthalf1">
                    <h1><b>Payment Due</b></h1>
                    {payment ? <h1>{payment}</h1> : <h1>N/A</h1> }
                   </div>
                   <div className="righthalf1">
                    <h1><b>Property address</b></h1>
                    <h1>Street Address 1</h1>
                    <h1>Street Address 2</h1>
                    <h1>City, State, Zip</h1>
                   </div>
                   <div className="righthalf2">
                   <h1><b>Contact Details</b></h1>
                    <h1>Phone Number</h1>
                    <h1>Email Address</h1>
                   </div>
                </div>
                </div>
                <hr id="quotdetailshr" />
                <div className="invoicesubject3">
                {subject ?<h1 className="text-2xl font-bold">Invoice subject: {subject} </h1> : <h1 className="text-2xl font-bold">Invoice subject: N/A</h1>}    
                </div>

                <div className="newquoteformparams2">
                    <h1 id="param012"><b>Product/Service</b></h1>
                    <h1 id="param22"><b>Quantity</b></h1>
                    <h1 id="param32"><b>Unit Price</b></h1>
                    <h1 id="param42"><b>Line Total</b></h1>
                    
                </div>
                
                {lineItems && lineItems.map((lineItems) => {
                return(
                    <div className="itemlines2">
                    <h1 id="param012">{lineItems.productService}</h1>
                    <h1 id="param22">{lineItems.quantity}</h1>
                    <h1 id="param32">{lineItems.unitPrice}</h1>
                    <h1 id="param42">{lineItems.total}</h1>
                </div>
                )
            })
            }
                
            <div className="messageandsave2">
            {message ? <div className="newlistclientmessage">{message}</div>: <div className="newlistclientmessage">N/A</div>}
            
            <div className="totalnsave2">
            {invoiceTotal ? <h1><b>Invoice total: {invoiceTotal}</b></h1> : <h1><b>Invoice total: N/A</b></h1> }   

            </div>
            </div>
        </div>
    );
}
 
export default NewInvoiceDetailsList;